import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APGoalSetsQuery } from '../../../plan/queries/ap_goal_sets_query';
import { APGoalsQuery } from '../../../plan/queries/ap_goals_query';
export class GoalSetsTitleController {
  private showGoals = false;
  private goalSetTitle = '';
  constructor(
    private ngAPGoalSetsQuery: APGoalSetsQuery,
    private loadGoalsCommand: ICommand,
    private ngAPGoalsQuery: APGoalsQuery
  ) {}
  getGoals(goal: { id: number; title: string }) {
    this.goalSetTitle = `${goal.title}`;
    this.loadGoalsCommand(goal.id).then(() => {
      this.showGoals = true;
    });
  }
  close() {
    this.showGoals = false;
  }
}

class GoalSetsTitleComponent implements ng.IComponentOptions {
  public controller: any;
  public templateUrl: any;
  public bindings: any;

  constructor() {
    this.controller = GoalSetsTitleController;
    this.bindings = {};
    this.templateUrl = 'capability-ng-academic-planner/src/global/components/goal_sets_title/goal_sets_title.html';
  }
}

angular.module('capability-ng-academic-planner').component('goalSetsTitle', new GoalSetsTitleComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/goal_sets_title/goal_sets_title.ts